import { defineMessages } from 'react-intl';

export default defineMessages({
  promoDiscount: {
    id: 'DiscountRow.promoDiscount',
    defaultMessage: 'Promo/voucher discount',
  },
});
